var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('trusteeship-dialog',{attrs:{"open":_vm.visible,"mode":"confirm","platform-name":_vm.platformName,"loading":_vm.loading,"reject-loading":_vm.rejectLoading},on:{"agree":_vm.handleAgree,"reject":_vm.handleReject,"dismiss":_vm.handleDismiss}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }